@if (item) {
  <div class="file-preview">
    <mat-icon>description</mat-icon>
    <span class="file-name">{{ item.name }}</span>
    @if (itemFormIndex !== undefined) {
      <mat-icon (click)="removeItem()" class="remove-icon">close</mat-icon>
    }
  </div>
}
